module.exports = __webpack_public_path__ + "static/media/rejected_coupon_1.d9f1342a.svg";